import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { CardDetails } from "@/components/CardDetails";
import { useRef, useState } from "react";
import { ImperativeHandle } from "@/types/Form";
import { useTranslation } from "@/hooks/useTranslation";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";

type FormStepCardDetailsProps = {
  onStepSubmit: () => void;
};

export function FormStepCardDetails(props: FormStepCardDetailsProps) {
  const { onStepSubmit } = props;
  const t = useTranslation("_common");

  const cardDetailsRef = useRef<ImperativeHandle>(null);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async () => {
    setProcessing(true);

    const validation = await cardDetailsRef.current?.validate();
    setProcessing(false);

    if (validation?.isValid) {
      onStepSubmit();
      dispatchEvent(EventName.STEP_SUBMIT, {
        step_name: DetailsStep.CardDetails,
        data: {},
      });
    }
  };

  return (
    <div>
      <CardDetails ref={cardDetailsRef} />

      <div className={classes.pagination}>
        <Button size="large" disabled={processing} onClick={handleSubmit}>
          {t("complete-donation")}
        </Button>
      </div>
    </div>
  );
}
